<template>
    <div>
        <BaseDatatable :module="`acl`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'AclList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'name',
          sortField: 'name',
          title: this.$translate.t('Name')
        },
        {
          name: 'description',
          sortField: 'description',
          title: this.$translate.t('Description')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Role List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/acl/AclList.vue